import { TBroadcastScheduleProgramBodySegmentToolkitDeclarationForm } from '../types';

const DECLARATION_FORM_DEFAULT_VALUES: TBroadcastScheduleProgramBodySegmentToolkitDeclarationForm =
  {
    id: '',
    text: '',
    people_id: '',
    entity_score: 1,
    start_datetime: null,
    end_datetime: null,
    review_state: 1,
    entity_label: '',
  };

export { DECLARATION_FORM_DEFAULT_VALUES };
